import React from 'react';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { WidgetConfigurationHorizontalNav } from './ui/horizontal-nav/WidgetConfigurationHorizontalNav.tsx';

const LazyWidgetConfigurationHorizontalNav = lazyForPaint<typeof WidgetConfigurationHorizontalNav>(
	() =>
		import(
			/* webpackChunkName: "async-widget-configuration-nav" */ './ui/horizontal-nav/WidgetConfigurationHorizontalNav.tsx'
		).then(({ WidgetConfigurationHorizontalNav }) => WidgetConfigurationHorizontalNav),
	{
		includeInShellOnlySsrBundle: true,
		entryFsSsrLiftImportToModule: true,
	},
);

export const AsyncWidgetConfigurationNav = (): React.JSX.Element => (
	<Placeholder name="horizontal-csm-widget-configuration-nav" fallback={null}>
		<LazyWidgetConfigurationHorizontalNav />
	</Placeholder>
);
